import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Page } from '@/model/document2/page/page';
import { Design } from '@/model/document2/page/surface/design/design';
import { GroupLayer } from '@/model/document2/page/surface/design/layer/groupLayer';
import { Document } from '@/model/document2/document';

// 新規デザインコマンド
export class NewDesignCommand implements ICommandBase
{
    private position! : number;
    private page! : Page;
    private isReverse! : boolean;
    private document! : Document;
    private doneCallback! : () => void;

    constructor(position : number, page : Page, isReverse : boolean, document : Document, doneCallback : () => void)
    {
        this.position = position;
        this.page = page;
        this.isReverse = isReverse;
        this.document = document;
        this.doneCallback = doneCallback;
    }

    private get surface() { return this.page.getSurface(this.isReverse); }

    public do() : void
    {
        var design = this.surface.createNewDesign(this.position);

        // 連番対応
        this.document.updateDesignAfterAddDesign(design, this.isReverse);
        
        this.doneCallback();
    }

    public undo() : void
    {
        // デザイン削除
        this.surface.removeDesign(this.position);
        
        this.doneCallback();
    }

    public redo() : void
    {
        var design = this.surface.createNewDesign(this.position);

        // 連番対応
        this.document.updateDesignAfterAddDesign(design, this.isReverse);

        this.doneCallback();
    }
}
